import { ToggleButton, Button } from "@aws-amplify/ui-react"
import { useNavigate } from "react-router-dom"

const ExercisesHeader = ({
    onlyFavorites,
    onOnlyFavoritesClicked
}) => {
    const navigate = useNavigate()


    return (
        <div className="d-flex justify-content-between align-items-center my-2">


            <ToggleButton className="no-border" onClick={() => { onOnlyFavoritesClicked() }}>
                {!onlyFavorites &&
                    <div className="d-flex align-items-center">
                        <span className="me-2">All Exercises</span>
                        <span className="material-symbols-outlined">
                            favorite
                        </span>
                    </div>}
                {onlyFavorites &&
                    <div className="d-flex align-items-center">
                        <span className="me-2">Only Favorite</span>
                        <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>
                            favorite
                        </span>
                    </div>}
            </ToggleButton>


            <Button
                variation="primary"
                onClick={() => {
                    navigate('/exercises/new')
                }}
            >
                Create
            </Button>

        </div>
    )
}

export default ExercisesHeader